import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!

  return (_ctx.column.key === 'status' && _ctx.row.status)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(_ctx.row.status.name), 1),
        (_ctx.isInvoices && _ctx.row.status.code === 307)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.row.value), 1))
          : _createCommentVNode("", true)
      ]))
    : (_ctx.column.key === 'createdAt')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.row.createdAt)), 1)
        ], 64))
      : (_ctx.column.key === 'state' && _ctx.row.state)
        ? (_openBlock(), _createBlock(_component_cheap, {
            key: 2,
            class: _normalizeClass(["small", {
                red: _ctx.row.state.id === 49,
                yellow: _ctx.row.state.id === 47,
                green: _ctx.row.state.id === 48,
                'yellow--outline': _ctx.row.state.id === 72
            }])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.row.state.name), 1)
            ]),
            _: 1
          }, 8, ["class"]))
        : (_ctx.column.key === 'user' && _ctx.row.user)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.row.user.name), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key] || '-'), 1)
            ], 64))
}